<script>
import Base from "@/components/RequestDetailsForDefaultVue/RequestTickets.vue";

export default {
  name: "CustomerServiceFilesRequestTickets",
  extends: Base,
};
</script>
